import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link, useHistory } from "react-router-dom";
import AsyncSelect from "react-select/async";
import Select, { AriaOnFocus } from "react-select";
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  getPartyApi,
  getMachineOperatorStock,
  getUserByRoleId,
  getUserApi,
  getAssignCubesFillerToMachinOperators,
  getGraderProcessStockList,
  getCube,
} from "api";
import { withTranslation } from "react-i18next";
import { map } from "lodash";
import moment from "moment/moment";

class GraderProcessedStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      totalSize: 10,
      sizePerPage: 10,
      partyId: "",
      boilManId: "",
      machineOperatorId: "",
      toDate:  moment().format("YYYY-MM-DD"),
      fromDate: moment().subtract(1,"week").format("YYYY-MM-DD"),
      stockList: [],
      partyList: [],
      cubeList: [],
      machineOperatorList: [],
      boilManList: [],
      jangadId: "",
      machineId: "",
      status: "",
    };
  }

  async componentDidMount() {
    const partyList = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });
    if(partyList && partyList.data){
      this.setState({
        partyList: partyList.data.parties,
      })
    }
    const machineOperator = await getUserByRoleId("ROLE0000004");
    if(machineOperator && machineOperator.data){
      this.setState({
        machineOperatorList: machineOperator.data.users,
      })
    }
    const boilman = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000005",
    });
    if(boilman && boilman.data){
      this.setState({
        boilManList: boilman.data.users,
      })
    }
    const grader = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000002",
    });
    if(grader && grader.data){
      this.setState({
        graderList: grader.data.users,
      })
    }
    this.getCubeList(null);
    this.getStockList();
  }

  async getStockList() {
    const data = await getGraderProcessStockList({
      page: this.state.page,
      limit: this.state.sizePerPage,
      boilManId: this.state.boilManId,
      machineOperatorId: this.state.machineOperatorId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      beltId: this.state.beltId
    });
    if(data && data.data){
      this.setState({
        totalSize: data.data.count,
        stockList:
          data.data.machineOperatorStocks.length == 0
            ? [
                {
                  id: "0",
                  cubeBelt: {
                    cubeId: "0",
                    usedCylinder: 0,
                    processId: 0,
                    user: {
                      name: "0",
                    },
                  },
                  remarks: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockMachineOperatorInWards: [],
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                  updatedAt: "",
                  assignGraderToFillerStock: null,
                },
              ]
            : data.data.machineOperatorStocks,
      });
    }
    
  }

  async getCubeList(inputValue) {
    const stock = await getCube({
      page: 1,
      limit: 10,
      boilManId: null,
      fromDate: null,
      toDate: null,
      beltId: null,
      name: inputValue,
    });

    if (Array.isArray(stock.data.cubeBelts)) {
      this.setState({
        cubeList: stock.data.cubeBelts,
      });
      return [
        { label: "All", value: "" },
        ...stock.data.cubeBelts.map(x => {
          return { label: x.cubeId, value: x.id };
        }),
      ];
    } else return [];
  }
  async getBoilManList(inputValue) {
    const data = await getUserApi({
      page: null,
      limit: null,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      name: inputValue,
      roleId: "ROLE0000005",
    });
    this.setState({
      boilManList: data.data.users,
    });
    if (Array.isArray(data.data.users))
      return [
        { label: "All", value: "" },
        ...data.data.users.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }
  async getGraderList(inputValue) {
    const data = await getUserApi({
      page: null,
      limit: null,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      name: inputValue,
      roleId: "ROLE0000002",
    });
    this.setState({
      boilManList: data.data.users,
    });
    if (Array.isArray(data.data.users))
      return [
        { label: "All", value: "" },
        ...data.data.users.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }
  async getMachineOperatorList(inputValue) {
    const data = await getUserApi({
      page: null,
      limit: null,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      name: inputValue,
      roleId: "ROLE0000004",
    });
    this.setState({
      machineOperatorList: data.data.users,
    });
    if (Array.isArray(data.data.users))
      return [
        { label: "All", value: "" },
        ...data.data.users.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }

  render() {
    const promiseOptionsBoilMan = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getBoilManList(inputValue));
        }, 0);
      });
    const promiseOptionsMachineOperator = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getMachineOperatorList(inputValue));
        }, 0);
      });
    const promiseOptionsGrader = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getGraderList(inputValue));
        }, 0);
      });
    const promiseOptionsCube = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getCubeList(inputValue));
        }, 0);
      });
      
    this.columns1 = [
      {
        dataField: "id",
        text: "#",
      },
      {
        dataField: "cubeId",
        text: `${this.props.t("Belt Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.cubeBelt.cubeId;
        },
      },
      // {
      //   dataField: "usedCylinder",
      //   text: `${this.props.t('Used Cylinder')}`,
      //   sort: true,
      //   formatter: (cell, row) => {
      //     return row.cubeBelt.usedCylinder;
      //   },
      // },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.cubeBelt.process?.name;
        },
      },
      {
        dataField: "machineOperatorId",
        text: `${this.props.t("Machine Operator")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.user?.name;
        },
      },
      // {
      //   dataField: "boilmanId",
      //   text: `${this.props.t("Boil Man")}`,
      //   sort: true,
      //   formatter: (cell, row) => {
      //     return row.boilManUser?.name;
      //   },
      // },
      {
        dataField: "remarks",
        text: this.props.t("Filler Notes"),
        sort: true,
      },
      {
        dataField: "updatedAt",
        text: `${this.props.t("Assigned Date")}`,
        sort: true,
        formatter: cell => {
          return moment(cell).format("DD/MM/YYYY");
        },
      },
      {
        dataField: "totalDiomonds",
        text: `${this.props.t("Tot. Dia.")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.stockMachineOperatorInWards?.length;
        },
      },
      {
        dataField: "acceptDiomonds",
        text: `${this.props.t("Acp. Dia.")}`,
        sort: true,
        formatter: (cell, row) => {
          let acceptDiomond = row.stockMachineOperatorInWards?.filter(x => {
            return x.graderStatus == "A";
          }).length;
          return acceptDiomond;
        },
      },
      {
        dataField: "pendingDiomonds",
        text: `${this.props.t("Pen. Dia.")}`,
        sort: true,
        formatter: (cell, row) => {
          let acceptDiomond = row.stockMachineOperatorInWards?.filter(x => {
            return x.graderStatus == "A";
          }).length;
          return row.stockMachineOperatorInWards?.length - acceptDiomond;
        },
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => (
          <div className="btn-group">
          {row.id != "0" &&  <Link
              to={{
                pathname: "/grader-process-stock-accept-reject",
                query: { isEdit: 2, data: row },
              }}
            >
              <button className="py-2 px-2 border-0 rounded">
                <img src="images/dashboard-images/edit.svg" />
              </button>
            </Link>}
           
          </div>
        ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize,
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "grader flow";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={this.columns1}
        data={this.state.stockList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={this.columns1}
            data={this.state.stockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t("Processed Stock List")}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="">
                                <h4 className="text-black fw-bold">
                                  {this.props.t("Processed Stock List")}
                                </h4>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="date"
                                  className="fs-5 fw-bold text-black pe-3"
                                >
                                  {this.props.t("From Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="fromDate"
                                  value={this.state.fromDate}
                                  onChange={e =>
                                    this.setState(
                                      {
                                        stockList: [],
                                        fromDate: e.target.value,
                                      },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                                <label
                                  htmlFor="date"
                                  className="fs-5 fw-bold px-0 px-md-3 text-black"
                                >
                                  {this.props.t("To Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="toDate"
                                  value={this.state.toDate}
                                  onChange={e =>
                                    this.setState(
                                      { stockList: [], toDate: e.target.value },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Belt")}
                                    </label>
                                    <AsyncSelect
                                      id="jangadId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            beltId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      
                                      loadOptions={promiseOptionsCube}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.cubeList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.cubeId,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>

                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                                </div>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("BoilMan")}
                                    </label>
                                    <AsyncSelect
                                      id="boilManId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            boilManId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      
                                      loadOptions={promiseOptionsBoilMan}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.boilManList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.name,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Machine Operator")}
                                    </label>
                                    <AsyncSelect
                                      id="machineOperatorId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            machineOperatorId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      
                                      loadOptions={
                                        promiseOptionsMachineOperator
                                      }
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.machineOperatorList.map(
                                          x => {
                                            return {
                                              value: x.id,
                                              label: x.name,
                                            };
                                          }
                                        ),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    data={this.state.stockList}
                                    columns={this.columns1}
                                    onTableChange={() => false}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                              <div className="">
                                <h5>
                                  {this.props.t("Showing")}{" "}
                                  {(this.state.page - 1) *
                                    this.state.sizePerPage +
                                    1}
                                  -{" "}
                                  {this.state.totalSize < this.state.sizePerPage
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                        this.state.page >=
                                      this.state.totalSize
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                      this.state.page}{" "}
                                  of {this.state.totalSize}
                                </h5>
                              </div>
                              <div className="ms-auto">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}

export default withTranslation()(GraderProcessedStock);
